

export * from './default.component';



// WEBPACK FOOTER //
// D:/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/home/index.component.ts